import { Component, OnInit } from '@angular/core';
import { CompanyPickerModel } from './model/company-picker.model';
import { ModalService } from '@common_libraries/controls/modal/services/modal.service';
import { CompanyPickerModalComponent } from './component/company-picker-modal.component';


@Component({
    selector: 'app-company-picker',
    templateUrl: './company-picker.component.html',
    styleUrls: ['./company-picker.component.scss'],
    providers: [CompanyPickerModel],
    standalone: true,
    imports: [CompanyPickerModalComponent]
})
export class CompanyPickerComponent implements OnInit {

  constructor(public model: CompanyPickerModel, private modalService: ModalService) { }

  ngOnInit() {

  }

  public showAccountSelectModal() {
    this.modalService.open('account-select-modal');
  }
}
